import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { useSession } from '../../../contexts/SessionContext'
import DDIcon from '../../icons/DDIcon'
import styles from './Header.module.css'

// Spec §2 — merchant logo circle + name + "Secured Direct debit setup" line; back arrow
// only on "Add an account" (owned by Container, which knows the right back destination
// for new-user vs. returning-user-via-different-account). Close button logic ported
// verbatim from the legacy layout/v2/Header.js.
const Header = ({ showBack, onBack }) => {
  const { sessionData } = useSession()
  const navigate = useNavigate()

  const closeIframe = () => {
    if (window.self !== window.top) {
      window.parent.postMessage('close-iframe', '*')
    } else {
      sessionData?.charge_url ? window.location.replace(sessionData.charge_url) : navigate(-1)
    }
  }

  const handleClose = () => {
    const confirmed = window.confirm('Are you sure you want to cancel this payment?')
    if (confirmed) closeIframe()
  }

  const merchantName = sessionData?.merchantName || 'Checkout'

  return (
    <div className={styles.header}>
      <div className={styles.left}>
        {showBack && (
          <button type='button' className={styles.backButton} aria-label='Back' onClick={onBack}>
            <DDIcon name='back' />
          </button>
        )}
        {/* FLAG: spec wants a merchant logo image here; the first iteration's header was
            text-only (no logo field was ever read from sessionData). Falls back to the
            merchant's initial rather than guessing a field name. See final report. */}
        <span className={styles.logo}>{merchantName.charAt(0).toUpperCase()}</span>
        <div className={styles.nameBlock}>
          <div className={styles.merchantName}>{merchantName}</div>
          <div className={styles.secureLine}>
            <DDIcon name='header-lock' />
            <span>Secured Direct debit setup</span>
          </div>
        </div>
      </div>
      <button type='button' className={styles.closeButton} aria-label='Close' onClick={handleClose}>
        <DDIcon name='close' />
      </button>
    </div>
  )
}

Header.propTypes = {
  showBack: PropTypes.bool,
  onBack: PropTypes.func,
}

Header.defaultProps = {
  showBack: false,
}

export default Header
